import React, {useState} from 'react'
import {signInWithEmailAndPassword} from 'firebase/auth'

import {firebaseAuth} from '../lib/firebase'

interface EmailPasswordSignInProps {
  onSuccess: (idToken: string) => void
}

const EmailPasswordSignIn: React.FC<EmailPasswordSignInProps> = ({onSuccess}) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsSubmitting(true)

    try {
      const userCredential = await signInWithEmailAndPassword(firebaseAuth, email, password)
      const idToken = await userCredential.user.getIdToken()
      onSuccess(idToken)
    } catch {
      setError('Login failed. Check your email and password and try again.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form className='flex flex-col gap-4 w-full' onSubmit={handleSubmit} noValidate>
      <div className='flex flex-col gap-1'>
        <label htmlFor='email' className='text-sm font-medium'>Email Address</label>
        <input
          id='email'
          type='email'
          autoComplete='email'
          placeholder='Enter your email address'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className='input input-bordered w-full'
        />
      </div>
      <div className='flex flex-col gap-1'>
        <label htmlFor='password' className='text-sm font-medium'>Password</label>
        <input
          id='password'
          type='password'
          autoComplete='current-password'
          placeholder='Enter your password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className='input input-bordered w-full'
        />
      </div>
      {error && (
        <div className='text-sm text-error text-center'>{error}</div>
      )}
      <button type='submit' className='btn btn-primary w-full' disabled={isSubmitting}>
        {isSubmitting ? (
          <span className='flex items-center justify-center gap-2'>
            <span className='animate-spin rounded-full h-4 w-4 border-b-2 border-current'></span>
            Logging in with email
          </span>
        ) : 'Login with email'}
      </button>
    </form>
  )
}

export {EmailPasswordSignIn}
